import { createSlice } from '@reduxjs/toolkit';




const initialState = {
  customers:[]
};

export const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomers: (state, { payload }) => {
     
      state.customers = [...payload];
    },
    
   
    clearCustomersState: (state) => {
      state=initialState
    }
  }
});

export const { setCustomers, clearCustomersState } = customersSlice.actions;

export const customersData = (state) => state.customers;
export const getCustomerById = (id) => (state) => {
  return state.customers.customers.find((el) => el.id?.toString() === id?.toString());
};
export const customerDataForAutoComplete = (state) => {
  return state.customers.customers.map((el) => {
    return {
      ...el,
      label:  el.name_english + " " + el.name_urdu,
    };
  });
};



export default customersSlice.reducer;
